import Vue from 'vue'
import VueRouter from 'vue-router'
import Pay from '../views/Pay.vue'
import Gwloading from '../views/gw-loading.vue'
import Gwmain from '../views/gw-main.vue'
import LoginSuccess from '../views/LoginSuccess.vue'
import PayHandle from '../views/PayHandle.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/pay',
    name: '/pay',
    component: Pay
  },
  {
    path: '/',
    name: 'gw-loading',
    component: Gwloading
  },
  {
    path: '/gw-main',
    name: 'gw-main',
    component: Gwmain
  },
  {
    path: '/login_success',
    name: 'login_success',
    component: LoginSuccess,
  },
  {
    path: '/pay_handle',
    name: 'pay_handle',
    component: PayHandle,
  },
  // {
  //   path: '/:p',
  //   name: 'home',
  //   component: Pay
  // },
  // {
  //   path: '/:p/:channel',
  //   name: 'home',
  //   component: Pay
  // },
  // {
  //   path: '/:p/:channel/:invitecode',
  //   name: 'home',
  //   component: Pay
  // },
]

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes
})

export default router
